import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialStatussState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  statusForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const statussSlice = createSlice({
  name: "statuss",
  initialState: initialStatussState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getStatusById
    statusFetched: (state, action) => {
      state.listLoading = false;
      // APLICAR A MASCARA
      if (action.payload.statusForEdit && action.payload.statusForEdit.idStatus) {
        action.payload.statusForEdit.endCEPStatus = aplicarMascaraCEP(action.payload.statusForEdit.endCEPStatus);
      }
      state.statusForEdit = action.payload.statusForEdit;
      state.error = null;
    },
    // findStatuss
    statussFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createStatus
    statusCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // state.entities.push(action.payload.status);
    },
    // updateStatus
    statusUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.status.idStatus) {
          return action.payload.status;
        }
        return entity;
      });
    },
    // deleteStatus
    statusDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteStatuss
    statussDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      // state.entities = state.entities.filter(
      //   el => !action.payload.ids.includes(el.id)
      // );
    },
    // statussUpdateState
    statussStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
